class Source {
  constructor() {
    this.embeddable = true
    this.inputs = {
      MAIN: "1",
      VOD: "1",
      HLS: "1",
      MULTICAST: "1",
      RF: "1",
      HDMI1: "6",
      HDMI2: "6-1",
      HDMI3: "6-2"
    }
    this.interval = null
  }
  _init = async () => {
    const current = await this.get().catch(err => _$.error(err))

    if (current !== this.inputs.MAIN) await this.set(this.inputs.MAIN).catch(err => _$.error(err))

    this.interval = setInterval(() => __._source.refreshInputs(), 5000)
    return true
  }

  get = async () => {
    let promise = await _$.progress.create()

    /* Library Code */
    hcap.externalinput.getCurrentExternalInput({
      onSuccess: payload => {
        let result = [payload.type]
        if (payload.index) result.push(payload.index)

        promise.resolve(result.join("-"))
      },
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }
  set = async source => {
    if (!source) return false

    let promise = await _$.progress.create()
    source = source.split("-")

    /* Library Code */
    hcap.externalinput.setCurrentExternalInput({
      type: parseInt(source[0]),
      index: parseInt(source[1] || 0),
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }
  refreshInputs = async () => {
    Array.from(["COMPOSITE", "COMPONENT", "RGB", "SCART", "SVIDEO"]).map(function(source) {
      hcap.externalinput.isExternalInputConnected({
        type: hcap.externalinput.ExternalInputType[source],
        index: 0,
        onSuccess: function(s) {
          if (s.isConnected) __.source.inputs[source] = hcap.externalinput.ExternalInputType[source].toString()
          else delete __.source.inputs[source]
        },
        onFailure: function() {
          delete __.source.inputs[source]
        }
      })
      return true
    })
  }
}

export default Source
